import { IQueryStrictParams } from "../../../api/entities/page";
import { QueryPropertyType, QueryTypeMap } from "../../../utils/query-utils";
import { IShardRepositoryFilters } from "../../shard-clusters/filters/storage-node-list-filters/storage-node-list-filters";
import { IShardClusterAssociatedFilters } from "../../common/sections/filters/shard-cluster-associated-filters";

export type StorageNodeTabFilters = IShardClusterAssociatedFilters & Pick<IShardRepositoryFilters, 'storageTypeFilter'>;

export const defaultFilters: StorageNodeTabFilters = {
    searchText: null,
    shardClusterFilter: null,
    storageTypeFilter: null
};

export const filterNames = {
    searchText: "",
    shardClusterFilter: "Shard Cluster",
    storageTypeFilter: "Type"
};

type SearchNodeFilterParams = Omit<IQueryStrictParams, 'strict'> & {
    pool?: string;
    storageType?: string;
};

export const searchBarStorageNodePoolTypeFilterTypeMap: QueryTypeMap<SearchNodeFilterParams> = {
    q: QueryPropertyType.String,
    pool: QueryPropertyType.String,
    storageType: QueryPropertyType.String,
}
